import React from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from '../..';

const i18nFilters = 'components.TransactionsHistory.Filters';

interface Props {
  onChange: (e: any) => void;
  value: string;
  name?: string;
  label?: string;
  [x: string]: any;
}

export const SelectSettled = (props: Props) => {
  const { onChange, value, name, label, ...rest } = props;
  const translate = useTranslate();
  const t = (string: string) => translate(`${i18nFilters}.SelectSettled.${string}`);
  return (
    <SelectInput
      label={label || t('_')}
      options={[
        { value: '', text: t('any') },
        { value: 'true', text: t('true') },
        { value: 'false', text: t('false') },
      ]}
      onChange={onChange}
      value={value || ''}
      name={name || 'settled'}
      {...rest}
    />
  );
};
